import React from 'react'
import Step from '../../components/Step'
import ButtonsYesNo from '../../elements/ButtonsYesNo'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'
import HelpIcon from '../../elements/HelpIcon'


const heritageListed = fieldName('heritageListed');

export const rules = {
    [heritageListed]:[
        enforce.required("Required")
    ]
}


export default () => {
    const navigation = Resi.useNavigation();
   
    return (
        <Step>
            <h2>Is your building heritage listed? <HelpIcon label={heritageListed} message=""/></h2>
            <ButtonsYesNo field={heritageListed} callback={ navigation.goToNext } />
        </Step>
    )
}